import {outHttp} from './index'
import ElementUI from "element-ui";

function outRequest(url, method, data) {
    return outHttp({
        url: url,
        method: method,
        data: data
    })
}

function get(url, data) {
    return outRequest(url, 'get', data)
}

function post(url, data) {
    return outRequest(url, 'post', data)
}


export function appIdList(data) {
    return post('/appId/list', data)
}

export function updateAppId(data) {
    return post('/appId/update', data)
}

export function putInList(data) {
    return post('/putIn/list', data)
}

export function updatePutInConfig(data) {
    return post('/putIn/update', data)
}

export function appSelections() {
    return get('/report/appList')
}

export function mediaSelections() {
    return get('/report/mediaList')
}

export function searchBaseData(data) {
    return post('/report/searchBase', data)
}

export function searchMediaData(data) {
    return post('/report/searchMedia', data)
}

export function searchAppData(data) {
    return post('/report/searchApp', data)
}

export function searchMagnitudeAndIncome(data) {
    return post('/report/searchMagnitudeAndIncome', data)
}

export function searchAdTypeIncomeRate(data) {
    return post('/report/searchAdTypesRate', data)
}

export function searchWeekDate(data) {
    return post('/report/searchWeek', data)
}

export function handleDataWithMedia(data) {
    return post('/flowcash/catchData/media', data)
}

export function searchProxyReport(data) {
    return post('/report/searchProxyReport', data)
}

export function report(data) {
    return post('/report/report', data)
}

export function handleDataWithAppCost(startDt, endDt) {
    return get('/report/insertCost/' + startDt + '/' + endDt)
}

export function handleDataWithProxy(startDt, endDt) {
    return get('/rsyncdata/calproxydata/day/' + startDt + '/' + endDt)
}

export function middleReport(data) {
    return post('/middle/report', data)
}

export function reportDaily(data) {
    return post('/middle/reportDaily', data)
}

export function middleEdit(data) {
    return post('/middle/edit', data)
}

export function uploadList(data) {
    return post('/middle/upload/list', data)
}

function requestBuffer(url, method, data) {
    return outHttp({
        url: url,
        method: method,
        data: data,
        responseType: 'blob'
    })
}

export function downloadData(url, data, fileName) {
    return requestBuffer(url, 'post', data).then(res => {
        const link = document.createElement('a');//创建a标签
        try {
            let blob = res.data;   //如果后台返回的直接是blob对象类型，直接获取数据
            link.style.display = 'none';//隐藏
            // 兼容不同浏览器的URL对象
            const url = window.URL || window.webkitURL || window.moxURL;
            link.href = url.createObjectURL(blob);
            link.download = fileName;
            //下载的文件名称
            link.click();//触发click
            window.URL.revokeObjectURL(url);  //  URL.revokeObjectURL()方法会释放一个通过URL.createObjectURL()创建的对象URL. 当你要已经用过了这个对象URL,然后要让浏览器知道这个URL已经不再需要指向对应的文件的时候,就需要调用这个方法.
            ElementUI.Message({
                message: '导出Excel成功！',
                type: "success",
            });
        } catch (e) {
            console.log('下载的文件出错', e)
        }
    })
}